/*
 * Create event prevent html tag from scrolling
*/
export default {
    bind: function (el, binding, vnode) {
        var elem = binding.value && binding.value.element ? binding.value.element : 'html'
        if (binding.value && binding.value.toggle) {
            $(elem).css('overflow-y', 'auto')
        } else {
            $(elem).css('overflow-y', 'hidden')
        }
    },
    unbind: function (el, binding) {
        var elem = binding.value && binding.value.element ? binding.value.element : 'html'
        $(elem).css('overflow-y', 'auto')
    },
    componentUpdated: function (el, binding) {
        var elem = binding.value && binding.value.element ? binding.value.element : 'html'
        if (binding.value && binding.value.toggle) {
            $(elem).css('overflow-y', 'auto')
        } else {
            $(elem).css('overflow-y', 'hidden')
        }
    },
}
